<template>
  <div class="form">
    <div class="form__header">
      <h3>Перенос ученика</h3>
    </div>
    <div class="form__body">
      <p class="form__field">
        <span class="l_title">Новая команда</span>        
        <v-select 
          label="title" 
          :options="teams" 
          v-model="formData.team_id" 
          :reduce="option => option.id"
          class="required"
          :class="{
            valid: formData.team_id,
            invalid: !formData.team_id,
          }"
        >
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.title }}
              </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.title }}
            </div>
          </template>
        </v-select>        
      </p>
    </div>

    <div class="form__footer">
      <SubmitButton :isValid="isValid" @submit="submit" />
    </div>
  </div>
</template>

<script>
import { form_mix } from '../../../mixins/form_mix'

export default {
  props: ['data'],
  inject: ['http'],
  mixins: [ form_mix ],
  data() {
    return {
      formData: {
        team_id: '',
        student_id : ''
      },
      teams: [],
      requiredKeys: ['team_id']
    }
  },
  methods: {
    getTeams() {
      this.http.post('onGetTeamsWithTeacher').then(res => {
        this.teams = res.data
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
    },
    submit() {
      this.http.post('onMoveMatriusStudent', this.formData).then(res => {
        swal('Успешно!', 'Ученик перенесен', 'success')
        this.$emit('close-popup')
        this.$emit('move-student', this.formData.student_id )
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
    }
  },
  created() {
    this.formData.student_id = this.data
    this.getTeams()
  }
}
</script>

<style lang="scss" scoped>
.form {
  height: 80vh;
}
</style>